module.exports = __webpack_public_path__ + "static/media/Diaperhis.6af4e3eb.svg";